import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "./theme";

export function FilterButton({ icon, children, className = "", ...rest }) {
    const {
        altTextColor: fontColor,
        contrastTextColor: buttonColor,
        modularScale,
    } = useTheme();
    const fontSize = modularScale(-1);

    return (
        <button className={`ng-filter-button ${className}`} {...rest}>
            <img
                className="ng-filter-button__icon"
                src={icon}
                alt=""
                aria-hidden={true}
            />
            <span className="ng-filter-button__label">{children}</span>
            <style jsx>{`
                .ng-filter-button {
                    background-color: #fff;
                    color: ${fontColor};
                    border: 2px solid #fff;
                    border-radius: 6em;
                    padding: 0.5em 1.25em 0.5em 1.25em;
                    cursor: pointer;
                    font-size: 1em;
                    min-width: 9.375em;
                }
                .ng-filter-button__icon {
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 0.5em;
                    width: 1.5em;
                }

                .ng-filter-button:hover,
                .ng-filter-button:focus {
                    border-color: ${fontColor};
                    outline: 0;
                }
                [aria-expanded="true"] .ng-filter-button__icon {
                    filter: grayscale(100%) invert(1) contrast(200%);
                }
                .ng-filter-button__label {
                    font-size: ${fontSize}em;
                    font-weight: 600;
                    white-space: nowrap;
                    display: inline-block;
                    vertical-align: middle;
                }
                [aria-expanded="true"] {
                    background-color: ${buttonColor};
                    border-color: ${buttonColor};
                    color: #fff;
                }
                .ng-filter-button[aria-expanded="true"]:hover,
                .ng-filter-button[aria-expanded="true"]:focus {
                    border-color: #fff;
                }
            `}</style>
        </button>
    );
}

FilterButton.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    "aria-expanded": PropTypes.bool,
};
FilterButton.defaultProps = {
    className: "",
    "aria-expanded": undefined,
};

export function IconButton({
    as: Component = "button",
    icon,
    children,
    className = "",
    ...rest
}) {
    const { altTextColor } = useTheme();
    return (
        <Component className={`icon-button ${className}`} {...rest}>
            <img src={icon} aria-hidden={true} alt="" />
            {children}
            <style jsx>{`
                .icon-button {
                    background-color: #ffffff;
                    border-radius: 50%;
                    cursor: pointer;
                    text-align: center;
                    font-size: 1em;
                    height: 2em;
                    width: 2em;
                    border: 2px solid #fff;
                }
                .icon-button:hover,
                .icon-button:focus {
                    outline: 0;
                    border-color: ${altTextColor};
                }
                .icon-button img {
                    display: inline-block;
                    vertical-align: middle;
                    padding: 0.5em;
                }
            `}</style>
        </Component>
    );
}

export function LinkButton({ children, className = "", ...rest }) {
    const { linkTextColor } = useTheme();
    return (
        <button className={`link-button ${className}`} {...rest}>
            {children}
            <style jsx>{`
                .link-button {
                    color: ${linkTextColor};
                    border-bottom: 1px solid transparent;
                    cursor: pointer;
                }

                .link-button:focus,
                .link-button:hover {
                    outline: 0;
                    border-bottom: 1px solid;
                }
            `}</style>
        </button>
    );
}
